<ion-header class="ion-no-border">
  <ion-toolbar [color]="getStatusColor(data?.status || data?.Approved ? 'approved' : 'pending')">
    <ion-title>{{ type | uppercase }} DETAILS</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <!-- Summary Header -->
  <div class="summary-card" [style.border-left-color]="getStatusColor(data?.status || (data?.Approved ? 'approved' : 'pending'))">
    <div class="summary-main">
      <ion-avatar class="main-avatar">
        <img [src]="data?.Rider_imgUrl || data?.Driver_imgUrl || data?.imageUrl || '../../assets/imgs/about.svg'">
      </ion-avatar>
      <div class="summary-text">
        <h2>{{ data?.Rider_name || data?.Driver_name || data?.name || 'Unknown' }}</h2>
        <p class="status-badge" [class]="'status-' + getStatusColor(data?.status || (data?.Approved ? 'approved' : 'pending'))">
          {{ (data?.status || (data?.Approved ? 'Approved' : 'Pending')) | uppercase }}
        </p>
      </div>
    </div>
  </div>

  <!-- Action Buttons (Live Track) -->
  <div class="action-bar" *ngIf="type === 'ride' || type === 'delivery'">
    <ion-button expand="block" shape="round" color="primary" (click)="liveTrack()">
      <ion-icon slot="start" name="map"></ion-icon>
      Live Track on Map
    </ion-button>
  </div>

  <!-- Detailed Sections -->
  <div class="details-container">
    
    <!-- RIDE / DELIVERY SPECIFIC -->
    <ng-container *ngIf="type === 'ride' || type === 'delivery'">
      <section class="info-section">
        <div class="section-title">
          <ion-icon name="navigate-circle-outline"></ion-icon>
          <h3>Route Info</h3>
        </div>
        <div class="route-display">
          <div class="route-item">
            <div class="dot pickup"></div>
            <div class="route-text">
              <label>Pickup Location</label>
              <p>{{ data?.Rider_Location || data?.pickupAddress || 'N/A' }}</p>
            </div>
          </div>
          <div class="route-connector"></div>
          <div class="route-item">
            <div class="dot delivery"></div>
            <div class="route-text">
              <label>Destination</label>
              <p>{{ data?.Rider_Destination || data?.deliveryAddress || 'N/A' }}</p>
            </div>
          </div>
        </div>
      </section>

      <section class="info-section">
        <div class="section-title">
          <ion-icon name="cash-outline"></ion-icon>
          <h3>Financial Details</h3>
        </div>
        <ion-list lines="none">
          <ion-item>
            <ion-label>
              <p>Total Fare</p>
              <h2>{{ currencySymbol }}{{ data?.price || data?.estimatedPrice || 0 }}</h2>
            </ion-label>
            <ion-badge slot="end" color="light">{{ data?.cash ? 'Cash' : 'Paid' }}</ion-badge>
          </ion-item>
          <ion-item *ngIf="data?.discountedPrice">
            <ion-label>
              <p>Discounted Price</p>
              <h2>{{ currencySymbol }}{{ data?.discountedPrice }}</h2>
            </ion-label>
            <ion-badge slot="end" color="success">-{{ data?.discountPercent }}%</ion-badge>
          </ion-item>
        </ion-list>
      </section>

      <section class="info-section">
        <div class="section-title">
          <ion-icon name="people-outline"></ion-icon>
          <h3>Participants</h3>
        </div>
        <ion-list lines="none">
          <ion-item>
            <ion-icon name="person-outline" slot="start"></ion-icon>
            <ion-label>
              <p>Customer</p>
              <h3>{{ getRiderName() }}</h3>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="car-outline" slot="start"></ion-icon>
            <ion-label>
              <p>Driver</p>
              <h3>{{ getDriverName() }}</h3>
            </ion-label>
          </ion-item>
        </ion-list>
      </section>
    </ng-container>

    <!-- STORE ORDER SPECIFIC -->
    <ng-container *ngIf="type === 'store_order'">
      <section class="info-section">
        <div class="section-title">
          <ion-icon name="business-outline"></ion-icon>
          <h3>Order Flow</h3>
        </div>
        <div class="route-display">
          <div class="route-item">
            <div class="dot pickup"></div>
            <div class="route-text">
              <label>Vendor (Store)</label>
              <p>{{ getVendorName() }}</p>
              <p class="secondary-info">{{ data?.vendorAddress }}</p>
            </div>
          </div>
          <div class="route-connector"></div>
          <div class="route-item">
            <div class="dot delivery"></div>
            <div class="route-text">
              <label>Customer (Delivery Address)</label>
              <p>{{ getRiderName() }}</p>
              <p class="secondary-info" style="font-size: 11px; color: var(--ion-color-medium);">{{ data?.deliveryAddress?.address || 'N/A' }}</p>
            </div>
          </div>
        </div>
      </section>

      <section class="info-section">
        <div class="section-title">
          <ion-icon name="fast-food-outline"></ion-icon>
          <h3>Items List</h3>
        </div>
        <ion-list lines="full" style="background: rgba(var(--ion-color-step-100-rgb), 0.05); border-radius: 12px; padding: 4px;">
          <ion-item *ngFor="let item of data?.items" class="glass-item">
            <ion-label class="ion-text-wrap">
              <h3 style="font-weight: 700;">{{ item.quantity }}x {{ item.name }}</h3>
              <p *ngIf="item.option">Options: {{ item.option }}</p>
            </ion-label>
            <span slot="end" style="font-weight: 700; color: var(--ion-color-step-700);">{{ currencySymbol }}{{ (item.price * item.quantity) | number }}</span>
          </ion-item>
        </ion-list>
      </section>

      <section class="info-section">
        <div class="section-title">
          <ion-icon name="calculator-outline"></ion-icon>
          <h3>Bill Breakdown</h3>
        </div>
        <ion-list lines="none">
          <ion-item>
            <ion-label><p>Subtotal</p></ion-label>
            <h3 slot="end">{{ currencySymbol }}{{ (data?.total - (data?.deliveryFee || 0)) | number }}</h3>
          </ion-item>
          <ion-item *ngIf="data?.deliveryFee">
            <ion-label><p>Delivery Fee</p></ion-label>
            <h3 slot="end">{{ currencySymbol }}{{ data?.deliveryFee | number }}</h3>
          </ion-item>
          <ion-item class="total-row" style="border-top: 1px dashed var(--ion-color-step-200); margin-top: 8px; padding-top: 8px;">
            <ion-label><h2 style="font-weight: 800; color: var(--ion-color-primary);">Grand Total</h2></ion-label>
            <h2 slot="end" class="neon-text" style="font-weight: 800;">{{ currencySymbol }}{{ data?.total | number }}</h2>
          </ion-item>
        </ion-list>
      </section>

      <section class="info-section">
        <div class="section-title">
          <ion-icon name="call-outline"></ion-icon>
          <h3>Customer Contact</h3>
        </div>
        <ion-item>
          <ion-label>
            <p>Phone Number</p>
            <h3 style="letter-spacing: 1px;">{{ getCustomerPhone() }}</h3>
          </ion-label>
          <ion-button slot="end" fill="clear" [href]="'tel:' + getCustomerPhone()">
            <ion-icon name="call"></ion-icon>
          </ion-button>
        </ion-item>
      </section>
    </ng-container>

    <!-- DRIVER / RIDER SPECIFIC -->
    <ng-container *ngIf="type === 'driver' || type === 'rider'">
      <section class="info-section">
        <div class="section-title">
          <ion-icon name="person-circle-outline"></ion-icon>
          <h3>Profile Info</h3>
        </div>
        <ion-list lines="none">
          <ion-item>
            <ion-icon name="mail-outline" slot="start"></ion-icon>
            <ion-label>
              <p>Email Address</p>
              <h3>{{ data?.Driver_email || data?.Rider_email || data?.email || 'N/A' }}</h3>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="call-outline" slot="start"></ion-icon>
            <ion-label>
              <p>Phone Number</p>
              <h3>{{ data?.Driver_phone || data?.Rider_phone || data?.phone || 'N/A' }}</h3>
            </ion-label>
          </ion-item>
          <ion-item *ngIf="type === 'driver'">
            <ion-icon name="car-sport-outline" slot="start"></ion-icon>
            <ion-label>
              <p>Vehicle Details</p>
              <h3>{{ data?.Driver_car || 'N/A' }} ({{ data?.Driver_plate || 'N/A' }})</h3>
            </ion-label>
          </ion-item>
        </ion-list>
      </section>

      <section class="info-section">
        <div class="section-title">
          <ion-icon name="stats-chart-outline"></ion-icon>
          <h3>Account Stats</h3>
        </div>
        <ion-grid>
          <ion-row>
            <ion-col size="6">
              <div class="stat-box">
                <label>Rating</label>
                <div class="stat-val">
                  {{ data?.Driver_rating || data?.Rider_rating || 0 }}
                  <ion-icon name="star" color="warning"></ion-icon>
                </div>
              </div>
            </ion-col>
            <ion-col size="6" *ngIf="type === 'driver'">
              <div class="stat-box">
                <label>Earnings</label>
                <div class="stat-val success">
                  {{ currencySymbol }}{{ data?.Earnings || 0 }}
                </div>
              </div>
            </ion-col>
            <ion-col size="6" *ngIf="type === 'rider'">
              <div class="stat-box">
                <label>Wallet Balance</label>
                <div class="stat-val primary">
                  {{ currencySymbol }}{{ data?.walletBalance || 0 }}
                </div>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </section>
    </ng-container>

    <!-- Shared/Common Info -->
    <section class="info-section">
      <div class="section-title">
        <ion-icon name="time-outline"></ion-icon>
        <h3>System Details</h3>
      </div>
      <ion-list lines="none">
        <ion-item>
          <ion-label>
            <p>Created Date</p>
            <h3>{{ formatDate(data?.time || data?.createdAt || data?.timestamp) }}</h3>
          </ion-label>
        </ion-item>
        <ion-item *ngIf="data?.trackingCode || data?.orderNumber">
          <ion-label>
            <p>Reference Code</p>
            <h3>{{ data?.trackingCode || data?.orderNumber }}</h3>
          </ion-label>
        </ion-item>
      </ion-list>
    </section>

  </div>
</ion-content>
